<template>

    <modal-container class="modal-container--short">

        <!-- Top navbar -->
        <modal-header
            :title="''"
            :right="'close-dark'"
            :noIcon="true">
        </modal-header>

        <!-- Prompt content -->
        <prompt-div>

            <!-- Layout body -->
            <template v-slot:body>
                <lottie class="loading-animation--absolute-middle" :options="{animationData: $root.loadAnimation}" v-if="initLoad" />

                <div :class="{'invisible':initLoad}">
                    <img class="m-3" src="/images/illustration-cash-exists.svg">
                    <h3 class="font-weight-bolder font-xl">You're already pre-approved</h3>
                    <div v-if="differentFromExisting()">
                        <div class="text-dark-grey mb-6">Your <span class="font-weight-bolder" v-html="existingProductName"></span> is almost ready. If you want order a new item, you can change to cancel your on-going one. Hurry, your application will expire in <span v-html="existingRemainingDays"></span> days.</div>
                        <button class="btn btn-primary w-100 font-lg" @click="keepExisting()">Keep existing item</button>
                        <div class="text-green p-3 font-weight-bolder" @click="cancelThenCheckout()">Change item</div>
                    </div>
                    <div v-else>
                        <div class="text-dark-grey mb-6">Order summary is now available. Proceed to the pick up store. Hurry, your application will expire in <span v-html="existingRemainingDays"></span> days</div>
                        <button class="btn btn-primary w-100 font-lg" @click="keepExisting()">View order summary</button>
                    </div>
                </div>

            </template>
        </prompt-div>
    </modal-container>

</template>

<script>
    import productMixin from '../../../components/productMixin'

    export default {
        mixins: [productMixin],

        data: function() {
            return {
                initLoad: true,
                productForCheckout: null,
                existingProduct: null,
            }
        },
        methods: {
          keepExisting: function() {
            // analytics

            if(!this.$store.state.session.genPosCompatible) {
                this.$root.openModal('modal_situation', {
                    shortText: 'Your installment shopping is just one update away...',
                    longText: 'We are inviting you to shop with us! We just need you to update your app to the latest version so you can enjoy shopping in our Marketplace.'
                })
            } else {
                window.location.replace("/exit?location=mpl_nonprime")
            }
          },
          cancelThenCheckout: function() {
            // analytics

            this.startCheckoutProcess({productId: this.productForCheckout, source: this.$root.modalParams.source, gposChangeItem: true, gposPreapproved: true})
          },
          differentFromExisting: function() {
            let existingProductId = _.get(this.existingProduct, 'id', false);
            return !(this.productForCheckout === existingProductId)
          }
        },
        computed: {
            existingProductName: function() {
                return _.get(this.existingProduct, 'productName', '')
            },
            existingRemainingDays: function() {
                return _.get(this.$store.state.session.noticeDetails.data, 'daysLeft', '')
            },

        },
        created: function() {
            // analytics

            // set product being checked out
            this.productForCheckout = this.$root.modalParams.productForCheckout

            // set existing checked out product
            let data = this.$store.state.session.noticeDetails.data;
            axios
                .get("product/" + data.prevProductId + "/fetch")
                .then(response => {
                    this.existingProduct = response.data['product']

                    this.initLoad = false;
                })
        }
    }
</script>

<style scoped>
.prompt-container {
    margin: 0 2.8rem 1rem 2.8rem; /** override for text wrap **/
}
</style>
